import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createSectionFundsSelector } from '../redux/pages/selectors';
import { buildDemoFundIdSet } from '../utilities/demoFundUtils';

/** Demo fund ids for the active section (from Redux get_funds cache). */
export function useDemoFundIds(
  section: string,
  pageId?: string | null,
): Set<string> {
  const fundsSelector = useMemo(
    () => createSectionFundsSelector(section, pageId),
    [section, pageId],
  );
  const funds = useSelector(fundsSelector);
  return useMemo(() => buildDemoFundIdSet(funds), [funds]);
}
